import React, { Fragment } from 'react';
import EditBillingInformationDrawer from './Drawer';
import EditInvoiceDrawer from './InvoiceForm/InvoiceDrawer';

const BillingInformationEdit = () => (
  <Fragment>
    <EditBillingInformationDrawer />
    <EditInvoiceDrawer />
  </Fragment>
);

export default BillingInformationEdit;
